import { isSameExcludedPath } from "@toddle-edu/react-router-scroll";

export const excludedRoutes = {
  "/platform/:curriculumProgramId/courses": true,
};

export function scrollUpdateCallback(
  prevRouterProps,
  currentRouterProps,
  isElement
) {
  if (
    currentRouterProps.location.action === "POP" ||
    currentRouterProps.location.state?.restoreScroll === true
  ) {
    // If there's no previous router props (i.e., after a reload),
    // remove all scroll states from sessionStorage and skip updating scroll.
    if (prevRouterProps == null) {
      // No need to clear session storage when scrollContainer calls scrollUpdateCallback
      if (!isElement) {
        Object.keys(sessionStorage).forEach(key => {
          if (key.startsWith("@@History/@@scroll")) {
            sessionStorage.removeItem(key);
          }
        });
      }
      return false;
    }
    return isSameExcludedPath(
      prevRouterProps,
      currentRouterProps,
      excludedRoutes
    )
      ? [0, 0]
      : true;
  }

  return false;
}
